import React from "react";
import {
  Show,
  TextField,
  DateField,
  NumberField,
  SimpleForm,
  ReferenceField,
  ArrayField,
  Datagrid,
  BooleanField
} from "react-admin";

export const PhagesShow = (props) => {
  return (
    <Show {...props}>
      <SimpleForm>
        <TextField source="code" />

        <ReferenceField
          label="Sample"
          resource="phages"
          source="id_sample"
          reference="samples"
          link="show"
        >
          <TextField source="code" />
        </ReferenceField>

        <ReferenceField
          label="Bacteria of isolation"
          resource="phages"
          source="id_bacteria_of_isolation"
          reference="isolates"
          link="show"
        >
          <TextField source="code" />
        </ReferenceField>

        <TextField label="Phage method" source="phage_method" />
        <TextField label="Storage description" source="storage_description" />
        <TextField
          label="Strain of propagation"
          source="strain_of_propagation"
        />
        <NumberField label="Amount propagations" source="amount_propagations" />
        <TextField label="Aproximate PFUs" source="aproximate_pfus" />

        <TextField source="notes" label="Notes" multiline minRows={6} />

        <DateField
          source="createdAt"
          locales="es-UY"
          options={{ timeZone: "UTC" }}
          showTime
        />
        <DateField
          source="updatedAt"
          locales="es-UY"
          options={{ timeZone: "UTC" }}
          showTime
        />
        {/* Storage */}
        <div className="">STORAGE</div>

        <ArrayField source="phages_storages" label="Phages positions">
          <Datagrid>
            <ReferenceField
              source="id_storage"
              label="Storage"
              reference="storages"
              link={false}
            >
              <TextField source="storage" />
            </ReferenceField>
            <TextField source="tube_name" label="Tube name" />

            <NumberField source="tube_size" label="Tube size (ml)" />

            <TextField source="notes" label="Notes" multiline minRows={6} />
          </Datagrid>
        </ArrayField>

        {/* Host range */}
        {/* TODO separate isolates and clinical isolates in two tables */}
        <div className="">HOST RANGE</div>
        <ArrayField source="phages_hosts" label="Phage Host Range" >
          <Datagrid filter={{ is_external_isolate: true }}>
            <BooleanField source="is_external_isolate" />
            <ReferenceField
              label="Isolate"
              resource="phages_hosts"
              source="id_isolate"
              reference="isolates"
              link="show"
            >
              <TextField source="code" />
            </ReferenceField>
            <ReferenceField
              label="External Isolate"
              resource="phages_hosts"
              source="id_external_isolate"
              reference="external_isolates"
              link="show"
            >
              <TextField source="code" />
            </ReferenceField>


            <NumberField label="Concentration" source="concentration" />
            <NumberField label="Quantification" source="quantification" />

            <BooleanField label="Kills?" source="kills" />
            <TextField label="Intensity" source="intensity" />
            <TextField label="Susceptibility" source="susceptibility" />

            <TextField label="Notes" source="notes" />
          </Datagrid>
        </ArrayField>

      </SimpleForm>
    </Show>
  );
};
